// ! This file was auto-generated from the everest OpenAPI schema. Do not override this file.
export const Tags = {
    activities: "activities",
    adobesign: "adobesign",
    attachments: "attachments",
    clients: "clients",
    companies: "companies",
    contract_types: "contract types",
    crms: "crms",
    currencies: "currencies",
    documents: "documents",
    docusign: "docusign",
    esignatures: "esignatures",
    intake_forms: "intake forms",
    integrate_workflow: "integrate workflow",
    internal: "internal",
    issues: "issues",
    judgment_results: "judgment-results",
    packages: "packages",
    permissions: "permissions",
    routing: "routing",
    routing_configuration: "routing-configuration",
    salesforce: "salesforce",
    suppliers: "suppliers",
    ticket_stages: "ticket stages",
    tickets: "tickets",
    turn_tracking: "turn tracking",
    turn_tracking_parties: "turn tracking parties",
    version_backup: "version backup",
    versions: "versions",
    workflows: "workflows"
} as const;
export type TagName = (typeof Tags)[keyof typeof Tags];
